import script from "./SvgIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgIcon.vue?vue&type=script&setup=true&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=cdd514ce&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdd514ce"]])

export default __exports__